/**
 * Route and settings tab → permission key mapping for UI guards.
 */

export const ROUTE_PERMISSIONS = {
  '/': 'tab_erp',
  '/customers': 'tab_customers',
  '/crm': 'tab_crm_pipeline',
  '/crm-pipeline': 'tab_crm_pipeline',
  '/requisitions': 'tab_requisitions',
  '/orders': 'tab_orders',
  '/metadata': 'tab_metadata',
  '/email-queue': 'tab_email_queue',
  '/services': 'tab_services',
  '/board': 'tab_board',
  '/erp': 'tab_erp',
  '/erp/accounting': 'tab_accounting',
  '/erp/selling': 'erp_selling_view',
  '/sales': 'erp_selling_view',
  '/vendors': 'tab_vendors',
  '/buying': 'tab_buying',
  '/projects': 'tab_projects',
  '/finance/payouts': 'service_finance_view',
  '/users': 'tab_users',
  '/settings': 'tab_settings',
};

export const SETTINGS_TAB_PERMISSIONS = {
  profile: null,
  theme: null,
  endpoints: 'view_all_data',
  users: 'tab_users',
  roles: 'permission_manage',
  groups: 'group_manage',
  permissions: 'permission_manage',
  currency: 'tab_metadata',
  email: 'email_manage',
  'sales-templates': 'service_sales_manage',
  'org-tax': 'service_finance_manage',
  ocr: 'erp_bills_manage',
};

export function permissionForPath(pathname) {
  if (!pathname) return null;
  const base = pathname.split('?')[0];
  if (ROUTE_PERMISSIONS[base]) return ROUTE_PERMISSIONS[base];
  const segments = base.split('/').filter(Boolean);
  if (segments.length >= 1) {
    const root = `/${segments[0]}`;
    return ROUTE_PERMISSIONS[root] || null;
  }
  return null;
}

/** First usable app path for the signed-in user. */
export function getDefaultAppPath(hasPermission) {
  const check = typeof hasPermission === 'function' ? hasPermission : () => false;
  const candidates = [
    ['tab_erp', '/erp'],
    ['tab_customers', '/customers'],
    ['tab_services', '/services'],
    ['tab_settings', '/settings'],
  ];
  for (const [perm, path] of candidates) {
    if (check(perm)) return path;
  }
  return '/';
}
